var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"m-b-0 m-t-3"},[_vm._v(_vm._s(_vm.heading))])])}
var staticRenderFns = []

export { render, staticRenderFns }